import { Fragment } from "react";
import InnerHTML from "dangerously-set-html-content";
import { t } from "@/i18n-js/instance";
import { FormItem } from "@/react/components/SettingsApp/General/FormItem";
import { usePunditUserContext } from "@/react/contexts";
import { Form } from "@circle-react-uikit/Form";
import { I18N_ROOT } from "../";

export const ShowIoSBannerField = () => {
  const { currentCommunity } = usePunditUserContext();
  const { has_plus_plan: hasPlusPlan, name: communityName } =
    currentCommunity || {};

  return (
    <FormItem
      name="community_setting.show_ios_app_banner"
      translationRoot={I18N_ROOT}
      childrenWrapper={Fragment}
      isHorizontal
      {...(hasPlusPlan && {
        description: (
          <InnerHTML
            html={t(
              [
                I18N_ROOT,
                "community_setting.show_ios_app_banner_description_for_plus",
              ],
              {
                community_name: communityName,
              },
            )}
          />
        ),
      })}
    >
      <Form.ToggleSwitch
        name="community_setting.show_ios_app_banner"
        variant="small"
      />
    </FormItem>
  );
};
